export default __webpack_public_path__ + "static/media/GasPump.a3cc2818.svg";